export default "__VITE_ASSET__BdHa4fMo__"